import { Box, Button, Container, Typography } from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import serviceSectionBg from "../../assets/images/New/service_section_bg.png";
import serviceSectionBg1 from "../../assets/images/New/service_section_bg1.png";
import serviceSectionBg1m from "../../assets/images/New/service_section_bg1_m.png";

export default function PremiumServiceSection({
  title,
  subtitle,
  description,
  image,
  beforeImage,
  afterImage,
  features = [],
  imagePosition = "right",
}) {
  const isLeft = imagePosition === "left";

  return (
    <Box
      sx={{
        py: {
          xs: 6,
          md: 10,
        },

        backgroundImage: {
          xs: `url(${serviceSectionBg1m})`,
          md: `url(${serviceSectionBg1})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",

        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",

            flexDirection: {
              xs: "column",
              lg: isLeft ? "row-reverse" : "row",
            },

            alignItems: "center",

            gap: {
              xs: 4,
              md: 8,
            },
          }}
        >
          {/* CONTENT */}

          <Box
            sx={{
              flex: 1,
              //   position:"relative"
            }}
          >
            <Box
              sx={{
                position: "relative",

                p: {
                  xs: 3,
                  md: 5,
                },

                borderRadius: "40px",

                // background: "rgba(255,255,255,.82)",
                backgroundImage: `
          url(${serviceSectionBg})
        `,

                backgroundSize: "cover",

                backgroundPosition: "center",
                backdropFilter: "blur(24px)",

                // border: "1px solid rgba(255,255,255,.85)",

                boxShadow: "0 25px 80px rgba(0,87,255,.08)",

                overflow: "hidden",

                "&::before": {
                  content: '""',

                  position: "absolute",

                  width: 180,

                  height: 180,

                  borderRadius: "50%",

                  background: "radial-gradient(circle,#0057FF15,transparent)",

                  top: -50,

                  right: -50,
                },
              }}
            >
              <Box
                sx={{
                  display: "inline-flex",

                  alignItems: "center",

                  gap: 1.5,

                  px: {
                    xs: 2,
                    md: 2.5,
                  },

                  py: {
                    xs: 1,
                    md: 1.2,
                  },

                  borderRadius: "999px",

                  background: "rgba(255,255,255,0.55)",

                  backdropFilter: "blur(16px)",

                  border: "1px solid rgba(0,87,255,.08)",

                  boxShadow: "0 10px 30px rgba(0,87,255,.06)",

                  mb: 3,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,

                    color: "#0057ff",

                    fontSize: {
                      xs: "11px",
                      md: "13px",
                    },

                    letterSpacing: ".5px",

                    textTransform: "uppercase",
                  }}
                >
                  PREMIUM SERVICE
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontWeight: 900,

                  lineHeight: 1.05,

                  fontSize: {
                    xs: "38px",
                    sm: "46px",
                    md: "62px",
                  },

                  color: "#07122F",
                }}
              >
                {title}
              </Typography>

              <Typography
                sx={{
                  mt: 1,

                  color: "#0057FF",

                  fontWeight: 800,

                  fontSize: {
                    xs: "15px",
                    md: "18px",
                  },
                }}
              >
                {subtitle}
              </Typography>

              <Typography
                sx={{
                  mt: 2,

                  color: "#64748B",

                  lineHeight: 1.9,

                  fontSize: {
                    xs: "12px",
                    md: "15px",
                  },
                }}
              >
                {description}
              </Typography>

              {/* FEATURES */}

              <Box
                sx={{
                  mt: 2,

                  display: "flex",

                  flexWrap: "wrap",

                  gap: 1.5,
                }}
              >
                {features.map((item) => (
                  <Box
                    key={item}
                    sx={{
                      px: 2,

                      py: 1,

                      borderRadius: "50px",

                      background: "#fff",

                      border: "1px solid rgba(0,87,255,.08)",

                      boxShadow: "0 8px 25px rgba(0,87,255,.05)",

                      display: "flex",

                      alignItems: "center",

                      gap: 1,
                    }}
                  >
                    <CheckCircleIcon
                      sx={{
                        color: "#0057FF",

                        fontSize: {
                          xs: "10px",
                          md: "14px",
                        },
                      }}
                    />

                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: {
                          xs: "10px",
                          md: "14px",
                        },
                        color: "#12305F",
                      }}
                    >
                      {item}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Typography
                sx={{
                  mt: 4,

                  color: "#64748B",

                  fontWeight: 600,

                  fontSize: {
                    xs: "12px",
                    md: "14px",
                  },
                }}
              >
                Trusted by customers across Ajax, Pickering, Whitby & Surrounding Areas for premium
                garment care and restoration.
              </Typography>

              {/* BUTTONS */}

              <Box
                sx={{
                  mt: 5,

                  display: "flex",

                  flexWrap: "nowrap",

                  gap: 1.5,

                  width: "100%",
                }}
              >
                <Button
                  endIcon={<ArrowForwardIcon />}
                  component="a"
                  href="/contact"
                  sx={{
                    flex: 1,

                    minWidth: 0,

                    height: {
                      xs: 46,
                      md: 56,
                    },

                    px: {
                      xs: 1.5,
                      md: 4,
                    },

                    borderRadius: "50px",

                    background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                    color: "#fff",

                    fontWeight: 800,

                    fontSize: {
                      xs: "12px",
                      md: "15px",
                    },

                    textTransform: "none",

                    whiteSpace: "nowrap",

                    boxShadow: "0 15px 35px rgba(0,87,255,.20)",
                  }}
                >
                  Request Quote
                </Button>

                <Button
                  startIcon={<WhatsAppIcon />}
                  component="a"
                  href="https://wa.me/+19054283542"
                  sx={{
                    flex: 1,

                    minWidth: 0,

                    height: {
                      xs: 46,
                      md: 56,
                    },

                    px: {
                      xs: 1.5,
                      md: 4,
                    },

                    borderRadius: "50px",

                    border: "2px solid #25D366",

                    color: "#25D366",

                    fontWeight: 800,

                    fontSize: {
                      xs: "12px",
                      md: "15px",
                    },

                    textTransform: "none",

                    whiteSpace: "nowrap",
                  }}
                >
                  WhatsApp Us
                </Button>
              </Box>
            </Box>
          </Box>

          {/* IMAGE SIDE */}

          <Box
            sx={{
              flex: 1,

              width: "100%",
            }}
          >
            {/* MAIN IMAGE */}

            <Box
              component="img"
              src={image}
              alt={title}
              sx={{
                width: "100%",

                display: "block",

                borderRadius: "30px",

                boxShadow: "0 35px 90px rgba(0,87,255,.18)",

                transition: ".4s",

                "&:hover": {
                  transform: "scale(1.02)",
                },
              }}
            />

            {/* BEFORE AFTER */}

            {beforeImage && afterImage && (
              <Box
                sx={{
                  display: "flex",

                  gap: 2,

                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    flex: 1,

                    p: 1.5,

                    borderRadius: "20px",

                    background: "rgba(255,255,255,.92)",

                    boxShadow: "0 12px 35px rgba(0,87,255,.08)",
                  }}
                >
                  <Typography
                    sx={{
                      mb: 1,

                      fontWeight: 800,

                      textAlign: "center",
                    }}
                  >
                    Before
                  </Typography>

                  <Box
                    component="img"
                    src={beforeImage}
                    sx={{
                      width: "100%",

                      borderRadius: "16px",
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    flex: 1,

                    p: 1.5,

                    borderRadius: "24px",

                    background: "rgba(255,255,255,.92)",

                    boxShadow: "0 12px 35px rgba(0,87,255,.08)",
                  }}
                >
                  <Typography
                    sx={{
                      mb: 1,

                      fontWeight: "bold",

                      textAlign: "center",
                      color: "#000",
                    }}
                  >
                    After
                  </Typography>

                  <Box
                    component="img"
                    src={afterImage}
                    sx={{
                      width: "100%",

                      borderRadius: "18px",
                    }}
                  />
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
